/**
 * PLP tile GA4 promotion tracking.
 *
 * Fires `view_promotion` once per tile when it first enters the viewport,
 * and `select_promotion` when the tile link is clicked. Event shape follows
 * GA4 ecommerce spec so the standard Promotions report picks it up.
 */
(function () {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  function tileItem(el) {
    return {
      promotion_id: el.dataset.promotionId || '',
      promotion_name: el.dataset.promotionName || '',
      creative_slot: el.dataset.creativeSlot || '',
      location_id: el.dataset.locationId || '',
    };
  }

  function push(event, el) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: event,
      ecommerce: { items: [tileItem(el)] },
    });
  }

  function bindClick(el) {
    if (el.dataset.plpTileClickBound) return;
    el.dataset.plpTileClickBound = '1';
    el.addEventListener('click', function () {
      push('select_promotion', el);
    });
  }

  function observeImpression(el, observer) {
    if (el.dataset.plpTileViewed) return;
    observer.observe(el);
  }

  function init() {
    var tiles = document.querySelectorAll('[data-plp-tile]');
    if (!tiles.length) return;

    var observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.dataset.plpTileViewed) return;
          el.dataset.plpTileViewed = '1';
          push('view_promotion', el);
          obs.unobserve(el);
        });
      }, { threshold: 0.5 });
    }

    tiles.forEach(function (el) {
      bindClick(el);
      if (observer) observeImpression(el, observer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
